class CustomAPOForm {
    constructor() {
        this.isInstallationInquiryFormSubmitted = false;
        this.isInstallationRequired  = false;
        this.hasShopifyForm = false;
        this.InquiryFormId = 'gate-installation-inquiry-form-question';
        this.APOAccordionTitleWrapper = 'apo-option-group';
        this.APOAccordionClass = 'apo-group-accordion';
        this.APOShowClass = 'apo-show';
        this.InquiryFormGroupId = 'gate-installation-inquiry-form-group';
        this.basePrice  = 0;
        this.extrasPrice = 0;
        this.totalPrice = 0;
        // PDP Changes
        this.hidePDPInstallationContactUsBox()
        this.addPDPFormToPrice()
        this.groupedValues = {}

    }

    init() {
        this.clearExistingAPOAccordionClickHandlers()
        this.setupAPOAccordionClickEventListener();
        this.setupInquiryFormAccordionClickEventListener();
        this.setupInquiryFormOptionClickListeners();
        this.setupFormOpenAndCloseEventListener();
        this.setupAPONavigationButtons()
        this.hideSvgToggleAccordionsArrows();
        this.prependStepNumberToAPOAccordionTitles();
        this.waitForElementsByQuerySelectorAll('.apo-option-group', (optionGroups) => {
            this.showAPOFirstAccordion();
            // Look for Form
            this.waitForElementByQuerySelector('form-embed', () => {
                console.log("Custom APO - [Shopify Form Found]")
                // this.showAPOFirstAccordion()
                this.hasShopifyForm = true;
                this.showOnlyInquiryFormAccordion();
                const steps = document.querySelectorAll('.step-circle');
          this.reFormNumberSteps();
            })
        });

        this.waitForBannerSuccess()
        this.initSetBasePrice()
        this.watchBasePrice()
        this.watchExtrasPrice()

        // Set Variant Fields
        this.waitForAllElementsToExsitByQuerySelector([
            '[name="option-avis-0"], [name="option-avis-1"]', 
            '.data-variant-option-0, .data-variant-option-1', 
            '.apo-option-group'
        ], () => {
            console.log("Custom APO - [All Field Exist]")
            this.setDefaultVariant();
            this.customShopifyVariantFields();
            this.defaultSelectedShopifyVariantFields();
            // Add any additional logic needed for .apo-option-group here
        });



    }
getScrollableParent(element) {
    let parent = element.parentElement;
    while (parent) {
        const overflowY = window.getComputedStyle(parent).overflowY;
        const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
        if (isScrollable && parent.scrollHeight > parent.clientHeight) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}

    setDefaultVariant() {
        this.waitForElementByQuerySelector('.data-variant-option-0 select.custom-apo-select', () => {
            if(document.querySelector('.data-variant-option-0 select.custom-apo-select')) {
                for (let i = 0; i <= 2; i++) {
                    const selector = `.data-variant-option-${i} select.custom-apo-select`;
                    const selectElement = document.querySelector(selector);
                    if (selectElement && selectElement.options.length > 0) {
                        selectElement.selectedIndex = 0;
                        const event = new Event('change', { bubbles: true });
                        selectElement.dispatchEvent(event);
                    }
                const url = new URL(window.location.href);
                url.searchParams.delete('variant');
                window.history.replaceState({}, '', url);
                }
            }
        })
    }

    defaultSelectedShopifyVariantFields() {
        // console.log("defaultSelectedShopifyVariantFields() Ran")

        // console.log("defaultShopifyVariantFields() Ran inside");
        const activeVariantIds = this.getActiveCheckedVariantIds().reverse();

        const items = document.querySelectorAll('.custom-apo-select')
        // console.log('!important items', items)

        items.forEach((item, index) => {
            // console.log('Item value:', item.value);
            item.value = activeVariantIds[index];
            // console.log('Active Variant ID:', activeVariantIds[index])
        })
    }

    getActiveCheckedVariantIds() {
        // Get all input elements with ID starting with "avis-option-value-item-"
        const inputs = document.querySelectorAll('input[id^="avis-option-value-item-"]');

        // Filter those that are checked and map to their data-variantid
        const checkedVariantIds = Array.from(inputs)
            .filter(input => input.checked)
            .map(input => input.getAttribute('data-variantid'));

        return checkedVariantIds;
    }

    customShopifyVariantFields() {
            // console.log("!important customShopifyVariantFields()");

            const radioButtons = this.getRadioButtons();
            const groupedValues = this.groupRadioButtonValues(radioButtons);

            // Create and append select dropdowns for each group
            Object.keys(groupedValues).forEach(optionIndex => {
                this.createSelectDropdown(groupedValues[optionIndex], optionIndex);
            });


    }

    getRadioButtons() {
        // Find all radio buttons with names starting with "option-avis-"
        const formElements = document.querySelectorAll('input[name^="option-avis-"]');
        // console.log("Custom APO - [Radio Buttons Found]", formElements);
        return formElements;
    }

    groupRadioButtonValues(radioButtons) {
        const groupedValues = {};

        radioButtons.forEach(radio => {
            const parentOption = radio.closest('.avis-swatch-option');
            const optionName = parentOption.querySelector('.avis-option-name').getAttribute('data-name');
            const optionIndex = parentOption.getAttribute('data-option-index');

            if (!groupedValues[optionIndex]) {
                groupedValues[optionIndex] = { optionName, options: [] };
            }

            groupedValues[optionIndex].options.push({
                value: radio.value,
                dataVariantId: radio.getAttribute('data-variantid'),
                name: radio.name
            });
        });

        // console.log("!important grouped values", groupedValues)

        return groupedValues;
    }

    createSelectDropdown(group, optionIndex) {
        // console.log("!important Create Dropdown")
        // console.log("!import group", group)
        // console.log("!import optionIdex", optionIndex)
        const selector = `.data-variant-option-${optionIndex}`;
        const divElement = document.querySelector(selector);
        // console.log("!important divElement", divElement)

        if (divElement) {
            // console.log("!importing devElment Found")
            const selectElement = document.createElement('select');
            selectElement.className = 'avp-productdescfont avp-productoptiontextcolor avp-productoptionbackground custom-apo-select';

            group.options.forEach(item => {
                // console.log('!important Item:', item);
                const option = document.createElement('option');
                option.value = item.dataVariantId;
                option.text = item.value;
                const indexWithoutPrefix = item.name.replace('option-avis-', ''); // Remove the prefix
                option.setAttribute('index', indexWithoutPrefix)
                selectElement.appendChild(option);
            });

            selectElement.addEventListener('change', event => this.handleSelectChange(event));
            divElement.appendChild(selectElement);
        }
    }

    handleSelectChange(event) {
        // console.log('handleSelectChange() Ran');
        // console.log('event target value', event.target.value);
        const selectedVariantId = event.target.value;
        const index = event.target.selectedOptions[0].getAttribute('index');
        // console.log('Index:', index)
        const inputElement = document.querySelector(`label[for^="avis-option-value-item-${selectedVariantId}"][for$="${index}"]`);
        console.log('Input element:', inputElement);
        if (inputElement) {
            // console.log('Input element with data-variantid:', selectedVariantId)
            // console.log('Input element found:', inputElement);
            inputElement.click();
        }

        // Update the variant parameter in the URL
        // const url = new URL(window.location);
        // url.searchParams.set('variant', selectedVariantId);
        // window.history.pushState({}, '', url);

        this.hideDropdownOptions();
    }

    hideDropdownOptions() {
        const dropdownOptions = document.querySelectorAll('.avis-option-values.avis-dropdown-option');
        dropdownOptions.forEach(element => {
            element.style.display = 'none';
        });
    }




    hidePDPInstallationContactUsBox() {
        this.waitForElementByQuerySelector('.product-details__block > .product-text', (element) => {
            // console.log("Custom APO - [Installation Contact Us Box Found]")
            if (element.querySelector('p > strong') && element.querySelector('p > strong').textContent.includes('Need installation for one of our gates or customised sized widths')) {
                element.style.display = 'none';
              }
        })
    }

    initSetBasePrice() {
        this.waitForElementByQuerySelector('[data-price]', (element) => {
            const basePrice = parseFloat(element.innerText.replace('£', '').replace(',', ''));
            this.basePrice = basePrice
            this.setFormBasePrice(basePrice)
        })
    }

  
    watchBasePrice() {

        this.waitForElementByQuerySelector('[data-price]', (element) => {
            const targetNode = document.querySelector('.price__current');

            if (!targetNode) {
                // console.error('Element not found: .price__current');
                return;
            }

            // Define the callback for mutations
            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        const moneyNode = targetNode.querySelector('span.money');
                        if (moneyNode) {
                            const newValue = parseFloat(moneyNode.innerText.replace('£', '').replace(',', ''));
                            if (!isNaN(newValue)) {
                                this.basePrice = newValue;
                                // console.log('The inner text has changed to: ', moneyNode.innerText);
                                this.totalPrice = this.basePrice + this.extrasPrice;
                                this.setFormBasePrice(this.totalPrice);
                            }
                        }
                    }
                }
            };

            // Create a MutationObserver instance
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, { childList: true, characterData: true, subtree: true });

            // console.log('Observer is now watching for changes to .price__current.');

            return observer;  // Return the observer if needed
        });
    }


    watchExtrasPrice() {
      // console.log("test");
        this.waitForElementByQuerySelector('#avp-productoption-totalpriceadd', (element) => {
            console.log('Element found: #avp-productoption-total-add');
            const targetNode = document.querySelector('#avp-productoption-total-add');
            console.log('Target node:', targetNode);

            if (!targetNode) {
                // console.error('Element not found: #avp-productoption-total-add');
                return;
            }

            // Define the callback for mutations
            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        const moneyNode = targetNode.querySelector('#avp-productoption-totalpriceadd');
                        if (moneyNode) {
                            const newValue = parseFloat(moneyNode.innerText.replace('£', '').replace(',', ''));
                          console.log(newValue);
                            if (!isNaN(newValue)) {
                                this.extrasPrice = newValue;
                                console.log('Extra price', moneyNode.innerText);
                                this.ExtrasPrice = newValue;
                                this.totalPrice = this.basePrice + this.extrasPrice;
                                this.setFormBasePrice(this.totalPrice);
                            }
                        }
                    }
                }
            };

            // Create a MutationObserver instance
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, { childList: true, characterData: true, subtree: true });

            // console.log('Observer is now watching for changes to #avp-productoption-total-add');

            return observer;  // Return the observer if needed
        });
    }






    setFormBasePrice(price) {

        document.querySelector('.order-form-price').innerText = '£' + price.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }


    addPDPFormToPrice() {
        this.waitForElementByQuerySelector('.product__price > .price__current', (element) => {
            // Add a span with the text "from" to the first child
            const span = document.createElement('span');
            // span.innerText = 'From ';
            span.style.fontSize = '14px'; // Set font size
            span.style.color = 'grey'; //
            element.insertBefore(span, element.firstChild); // Insert the span before the first child

        })
    }

    // Waits for  single element to exist by query selector
    waitForElementByQuerySelector(selector, callback) {
        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);
            if (element) {
                observer.disconnect(); // Stop observing once the element is found
                callback(element); // Call the callback with the found element
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }

    // Watches for all elements to exist by query selector ()
    waitForElementsByQuerySelectorAll(selector, callback) {
        const observer = new MutationObserver(() => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                observer.disconnect();
                callback(elements);
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }

    // Watches for all elements to exist by query selector
    waitForAllElementsToExsitByQuerySelector(selectors, callback) {
        const observer = new MutationObserver(() => {
            const elements = selectors.map(selector => document.querySelector(selector));
            const allExist = elements.every(element => element !== null);

            if (allExist) {
                console.log("all elements exist", allExist)
                observer.disconnect(); // Stop observing
                callback(elements); // Call the callback with the elements
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }


 setupAPOAccordionClickEventListener() {
    this.waitForElementsByQuerySelectorAll(
        ".apo-option-group",
        (optionGroups) => {
            optionGroups.forEach((optionGroup) => {
                const accordion = optionGroup.closest(`.${this.APOAccordionClass}`);
                if (!accordion) return;

                optionGroup.addEventListener("click", (event) => {
                    console.log("Accordion clicked:", accordion);
                    this.showOnlySelectedAccordion(accordion);
                });
            });
        }
    );
}

    setupInquiryFormAccordionClickEventListener() {
        this.waitForElementByQuerySelector('[data-inquiry-form-group]', (formAccordion) => {
            formAccordion.addEventListener('click', () => {
                this.showOnlyInquiryFormAccordion();
            });
        });
    }

   // Main Open & Close Form Buttons
   hideFormOpenButton() {
        const openFormButton = document.querySelector('[data-custom-apo-form-open-button]');
        openFormButton.style.display = 'none';
    }

    showFormOpenButton() {
        const openFormButton = document.querySelector('[data-custom-apo-form-open-button]');
        openFormButton.style.removeProperty('display');
    }

    closeForm() {
        const form = document.querySelector('[data-custom-apo-form]');
        if(form) {
            form.style.display = 'none'
        }
    }

    openForm() {
        const form = document.querySelector('[data-custom-apo-form]');
        if(form) {
            form.style.removeProperty('display');
        }
    }

    // Shopify Accordion Form
    showFormInitialQuestions() {
        const openButton = document.querySelector('[data-preliminary-installation-question]');
        openButton.style.removeProperty('display');
    }

    hideFormInitialQuestions() {
        const openButton = document.querySelector('[data-preliminary-installation-question]');
        openButton.style.display = 'none'
    }

    showPreliminaryInstallationInquiryQuestions() {
        document.querySelector('[data-preliminary-installation-question]').style.removeProperty('display');
    }

    hidePreliminaryInstallationInquiryQuestions() {
        document.querySelector('[data-preliminary-installation-question]').style.display = 'none';
    }

    hideInquiryInstallationForm() {
        document.querySelector('[data-custom-apo-inquiry-form]').style.display = 'none';
    }

    showInquiryForm() {
        document.querySelector('[data-custom-apo-inquiry-form]').style.removeProperty('display');
    }

    // APO Form Methods

    /* This function removes any existing click handlers from the APO accordion elements
    to prevent conflicts with newly added event handlers when opening and closing the accordions. */
    clearExistingAPOAccordionClickHandlers() {
        this.waitForElementsByQuerySelectorAll('.apo-option-group', () => {
            const optionGroups = document.querySelectorAll('div.apo-option-group');
            optionGroups.forEach((element) => {
                // Clone the element to remove all event listeners
                const newElement = element.cloneNode(true);
                element.parentNode.replaceChild(newElement, element);
            });
        });
    }

    closeAllAPOAccordions() {
        // console.log("closeAllAPOAccordions() Ran")
        const accordions = document.getElementsByClassName('apo-group-accordion');
        Array.from(accordions).forEach(accordion => {
            accordion.classList.remove('apo-show');
        });
    }

openSelectedAPOAccordion(selectedAccordion) {
    // console.log("openSelectedAPOAccordion() was triggered", selectedAccordion);
    selectedAccordion.classList.add(this.APOShowClass);

    setTimeout(() => {
        const scrollContainer = this.getScrollableParent(selectedAccordion);
        if (!scrollContainer) {
            // console.warn("No scrollable parent found.");
            return;
        }

        const offsetTop = selectedAccordion.offsetTop;
        const offsetAdjustment = 82; // 🟢 YOUR DESIRED OFFSET

        scrollContainer.scrollTo({
            top: offsetTop - offsetAdjustment,
            behavior: 'smooth',
        });

        // console.log("Scrolled modal container to:", offsetTop - offsetAdjustment);
    }, 350); // Should match accordion expand animation time
}



  showOnlySelectedAccordion(selectedAccordion) {
    // console.log("showOnlySelectedAccordion() Ran", selectedAccordion);
    this.closeAllAPOAccordions();

    if (this.hasShopifyForm) {
        this.hidePreliminaryInstallationInquiryQuestions();
        this.hideInquiryInstallationForm();
    }

    this.openSelectedAPOAccordion(selectedAccordion);
}


    showOnlyInquiryFormAccordion() {
        // console.log(" showOnlyInquiryFormAccordion() ran");
        this.showPreliminaryInstallationInquiryQuestions()
        this.closeAllAPOAccordions();
    }

    setupAPONavigationButtons() {
        this.waitForElementsByQuerySelectorAll('.ap-options__optiongroup', (elements) => {
            const elementsArray = Array.isArray(elements) ? elements : Array.from(elements);
            elementsArray.forEach((element, index) => {
                const wrapper = this.createAPONavigationButtonWrapper();
                // Append buttons to the wrapper

                // Use utility functions to check positions
                const { isFirstElement, isLastElement } = DOMUtils.checkElementPosition(index, elementsArray.length);

                if (!isFirstElement) {
                    const backButton = this.createAPOBackButton(elements, index); // Pass elements and index
                    wrapper.appendChild(backButton); // Append back button to wrapper
                }

                if (!isLastElement) {
                    const forwardButton = this.createAPOForwardButton(elements, index); // Pass elements and index
                    wrapper.appendChild(forwardButton); // Append forward button to wrapper
                }

                if (isLastElement) {
                    const addToCardButton = this.createAddToCardButton();
                    wrapper.appendChild(addToCardButton);
                }

                element.appendChild(wrapper); // Append the wrapper to the element
            });
        });
    }

    createAPOBackButton(elements, index){
        return DOMUtils.createElement({
            tagName: 'button',
            properties: {
                attributes: { class: 'apo-navigation-button apo-back-button' },
                innerText: 'Back',
                events: {
                    click: (event) => {
                        event.preventDefault();
                        this.openNextOrPreviousAccordion(elements, index, -1)
                    },
                }
            }
        });
    }

    createAPOForwardButton(elements, index){
        return DOMUtils.createElement({
            tagName: 'button',
            properties: {
                attributes: { class: 'apo-navigation-button apo-next-button' }, // Attributes
                innerText: 'Next',
                events: {
                    click: (event) => {
                        event.preventDefault();
                        this.openNextOrPreviousAccordion(elements, index, 1)
                    },
                }
            }
        });
    }

    createAddToCardButton() {
        return DOMUtils.createElement({
            tagName: 'div',
            properties: {
                attributes: { class: 'apo-submit-button' }, // Attributes
                innerText: 'Add To Cart',
                events: {
                    click: (event) => {
                        // event.preventDefault();
                        var atcElement = document.querySelector('[data-product-atc]');
                        if (atcElement) {
                            atcElement.click();  // Simulate the click
                            // console.log("Clicked the element!");
                        } else {
                            // console.log("Element not found!");
                              atcElement.click();
                        }
                        // console.log('Add To Cart');
                      
                    },
                }
            }
        });
    }

    createAPONavigationButtonWrapper() {
        const navigationButtonWrapper = DOMUtils.createElement({
            tagName: 'div',
            properties: {
                attributes: { class: 'apo-button-container' },
            },
        });
        return navigationButtonWrapper

    }

    openNextOrPreviousAccordion(accordionElements, currentAccordionIndex, navigationDirection) {
        // Remove the class from the current accordion's parent
        DOMUtils.removeClass(accordionElements[currentAccordionIndex].parentElement, this.APOShowClass);
        
        // Calculate the next accordion index
        let nextAccordionIndex = currentAccordionIndex + navigationDirection;
    
        // Loop until we find a valid accordion to show or go out of bounds
while (
    nextAccordionIndex >= 0 &&
    nextAccordionIndex < accordionElements.length
) {
    const parentElement = accordionElements[nextAccordionIndex].parentElement;
    const computedStyle = window.getComputedStyle(parentElement);

    if (computedStyle.display !== "none") {
        // console.log("Break");

        // ✅ Use your smart open/scroll method
        this.openSelectedAPOAccordion(parentElement);
        break;
    }

    nextAccordionIndex += navigationDirection;
}

    }
    




    waitForBannerSuccess() {
        ShadowDOMUtils.waitForElementByQuerySelector('[data-testid="banner-success"]', (element) => {
            // console.log('Banner success element is now in the DOM:', element);
            // dataLayer.push({'event':'osg-lead-form-submitted'});
            Shopify.analytics.publish('osg-lead-form-submitted');
          console.log("Kyle trigger");
            const apoElements = document.getElementsByClassName('apo-option-group');
            if (apoElements.length > 0) {
                apoElements[0].parentElement.classList.add('apo-show');
            }
            document.getElementById("gate-installation-inquiry-form").style.display = 'none';
            document.getElementById("gate-installation-inquiry-form-questions").style.display = 'none';
            document.querySelector(".step-name").innerHTML += '<span class="inquiry-success">Inquiry Successfully Sent</span>';
            this.removeClickHandlerInquiryForm()
        });
    }

    removeClickHandlerInquiryForm() {
        const inquiryFormGroup = document.getElementById('gate-installation-inquiry-form-group');
        if (inquiryFormGroup) {
            const newElement = inquiryFormGroup.cloneNode(true); // Clone the element to remove all event listeners
            inquiryFormGroup.parentNode.replaceChild(newElement, inquiryFormGroup); // Replace the old element with the new one
        }
    }




    setupInquiryFormOptionClickListeners() {
        const installationOptionButtons = document.querySelectorAll('[data-installation-option-type]');
        installationOptionButtons.forEach(button => {
            button.addEventListener('click', () => {
                // console.log("Button Clicked")
                this.handleInstallationOption(button);
            });
        });
    }

    handleInstallationOption(button) {
       const isInstallationRequest = button.dataset.value == 'true';
        if (isInstallationRequest) {
            this.removeSelectedStyleFromInquiryFormOptions()
            button.classList.add('selected-button');
            this.showInquiryForm()
            // console.log("True Clicked")
            this.isInstallationRequired = true;
        } else {
            this.removeSelectedStyleFromInquiryFormOptions()
            button.classList.add('selected-button');
            this.hideInquiryInstallationForm()
            this.hidePreliminaryInstallationInquiryQuestions();
            this.showAPOFirstAccordion();
            // console.log("False Clicked")
            this.isInstallationRequired = false;
        }
    }

    removeSelectedStyleFromInquiryFormOptions() {
        const installationOptionButtons = document.querySelectorAll('[data-installation-option-type]');
        installationOptionButtons.forEach(button => {
            button.classList.remove("selected-button")
        });
    }

showAPOFirstAccordion() {
    // console.log("showAPOFirstAccordion() called");

    const accordions = document.getElementsByClassName("apo-group-accordion");
    if (accordions.length > 0) {
        // Remove apo-show from all accordions first
        Array.from(accordions).forEach((accordion) => {
            accordion.classList.remove(this.APOShowClass);
        });

        // ✅ Use consistent scrolling logic
        this.openSelectedAPOAccordion(accordions[0]);
    }
}

    // Main Form
    setupFormCloseButtonEventListener() {
        const closeButton = document.querySelector('[data-custom-apo-form-close-button]');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                // console.log('Close Button')
                this.closeForm()
                this.showFormOpenButton()
                this.closeAllAPOAccordions()
                document.body.classList.remove('apo-no-scroll');
            });
        }
    }

    setupFormOpenButtonEventListener() {
        const openButton = document.querySelector('[data-custom-apo-form-open-button]');
        if (openButton) {
            openButton.addEventListener('click', () => {
                // console.log('Open Button')
                this.hideFormOpenButton()
                this.openForm()
                document.body.classList.add('apo-no-scroll');
                if(this.hasShopifyForm) {
                    this.closeAllAPOAccordions()
                }
                this.reFormNumberSteps();
                // automatedManualSelection.init();

            })
        }

    }

    setupFormOpenAndCloseEventListener() {
        this.setupFormCloseButtonEventListener()
        this.setupFormOpenButtonEventListener()
    }

    // Hides all the accordion's up and down arrows, as this is no longer a typical accordion but instead a form step process.
    hideSvgToggleAccordionsArrows() {
        this.waitForElementsByQuerySelectorAll('.svg-accordion', (elements) => {
            DOMUtils.hideElements(elements)
        });
    }

   // Prepends numbered steps to each of the accordions.
   prependStepNumberToAPOAccordionTitles() {
        this.waitForElementsByQuerySelectorAll('.apo-group-accordion', (accordions) => {
            Array.from(accordions).forEach((accordion, index) => {
                const titleElement = accordion.querySelector('.apo-title');


                if (titleElement) {
                    const stepNumber = `<span class="step-circle">${index + 1}</span>`; // Updated line
                    titleElement.innerHTML = `${stepNumber} ${titleElement.innerText}`;
                }
            });
        });
    }

    reFormNumberSteps() {
            // console.log("reformat numbers")
            // Select all step-circle elements
            const stepCircles = document.querySelectorAll('.step-circle');

            // Create an array to store the valid step elements
            const validSteps = [];

            // Loop through each step-circle
            stepCircles.forEach(circle => {
                // Find the nearest .ap-options__optiongroup-container or the nearest gate-installation-inquiry-form-group
                const optionGroupContainer = circle.closest('.ap-options__optiongroup-container');
                const inquiryGroupContainer = circle.closest('#gate-installation-inquiry-form-group');

                // Check if either container exists and if its display style is not set to 'none'
                const isOptionGroupVisible = optionGroupContainer && optionGroupContainer.style.display !== 'none';
                const isInquiryGroupVisible = inquiryGroupContainer && inquiryGroupContainer.style.display !== 'none';

                // If either of the containers is visible, add to valid steps
                if (isOptionGroupVisible || isInquiryGroupVisible) {
                    validSteps.push(circle); // Add the valid step-circle to the array
                }
            });

            // Set the inner text of each valid step-circle to its index + 1
            validSteps.forEach((step, index) => {
                step.innerText = (index + 1).toString(); // Set the inner text to index + 1
            });

            // You can log validSteps to see which elements were updated
            console.log("new valid steps", validSteps); // This will log the filtered step-circle elements 

    }
}


const myCustomAPOForm = new CustomAPOForm();
myCustomAPOForm.init();



const styles = `

    [class^="_textHeading_"] {
        display: none;
        color: red !important;
        font-size: 20px;
    }


    [class^="_formSubmitButton_"] {
        width: 100px !important;
        background: green !important;
        border: 1px solid darkgreen !important;
    }
    #form-container-ref > :first-child {
        justify-items: start !important;
    }
    [class^="_textBody_"] {
        text-align: left !important;
        font-size: 16px !important;
        font-family: Gill Sans Nova,sans-serif !important;
    }
    section[class^="_formHeader_"] {
        margin: 15px 0px 15px 0px !important;
    }
`;

ShadowDOMUtils.waitForShadowHostAndAddStyles('#app-embed', styles);

